import React from "react";
import { fmt, euros } from "@/lib/cee";

const FIELDS = [
  ["prixGlobal", "Global classique", "prixGlobal"],
  ["prixGlobalPrecarite", "Global précarité", "prixGlobalPrecarite"],
  ["prixMax", "Max classique", "prixClientMax"],
  ["prixMaxPrecarite", "Max précarité", "prixPrecariteMax"],
  ["prixMin", "Min classique", "prixClientMin"],
  ["prixMinPrecarite", "Min précarité", "prixPrecariteMin"],
];

/* Admin : prix forcés sur le dossier (prioritaires sur la grille de l'Obligé) */
export const PrixForces = ({ forces = {}, totals, onChange }) => {
  const set = (k, v) => onChange({ ...forces, [k]: v });
  const forced = Object.values(forces).some((v) => v !== "" && v != null);
  return (
    <div data-testid="admin-prix-forces" className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] uppercase tracking-wider text-[var(--dim)]">
          Grille : <b data-testid="calc-grille-name" className="text-[var(--ink)]">{totals.grille || "DEFAUT"}</b>
          {forced && <span className="ml-1 text-[var(--amber-text)]">· prix forcés</span>}
        </span>
        {forced && (
          <button type="button" data-testid="admin-prix-forces-reset" onClick={() => onChange({})} className="text-[11px] text-[var(--accent-text)] underline">
            Revenir à la grille
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, label, tk]) => (
          <label key={k} className="block">
            <span className="mb-1 block text-[10px] uppercase tracking-wider text-[var(--mute)]">{label} (€/MWh)</span>
            <input
              data-testid={`admin-force-${k}`}
              type="number" min="0" step="0.05"
              className="field-input py-1.5 font-mono text-sm"
              placeholder={fmt(totals[tk], 2)}
              value={forces[k] ?? ""}
              onChange={(e) => set(k, e.target.value)}
            />
          </label>
        ))}
      </div>
      <div data-testid="calc-prix-ponderes" className="grid grid-cols-4 gap-2 rounded-lg border border-[var(--line)] bg-[var(--inset)] p-2.5 text-center">
        {[["Global", "prixGlobalPondere"], ["Max", "prixMaxPondere"], ["Min", "prixMinPondere"], ["Choisi", "prixPondere"]].map(([l, k]) => (
          <div key={k}>
            <div data-testid={`calc-${k}`} className="font-mono text-sm font-bold text-[var(--ink)]">{fmt(totals[k], 2)}</div>
            <div className="text-[9px] uppercase tracking-wider text-[var(--mute)]">{l} pondéré</div>
          </div>
        ))}
      </div>
      <p className="text-[11px] leading-relaxed text-[var(--mute)]">
        Part GENIS (global − max pondérés) : <b data-testid="calc-part-genis" className="text-[var(--ink)]">{euros(Math.round(totals.margeInterne || 0))}</b> · prime au prix global :{" "}
        <b className="text-[var(--dim)]">{euros(Math.round(totals.primeBrute || 0))}</b>. Laissez un champ vide pour appliquer la grille de l'Obligé. Pondération : {fmt((1 - (totals.pctPrecarite || 0)) * 100)} % classique / {fmt((totals.pctPrecarite || 0) * 100)} % précarité.
      </p>
    </div>
  );
};
